
<div  cdkDropListGroup 
      class="drag-list position-relative flex-column gap-none" 
      ssCoreLoaderOutlet
      [ngClass]="{
        'gap-standard':!(showGroupsObs | async)
      }"
      [height]="'100%'"
      [keys]="['activity.reorder','activity.insert','process.update']"      
>
  
  <ng-container *ngFor="
      let activitiesGroupTuple of activitiesGroupedObs | async;
      trackBy: trackById;
      let idx = index
    ">

    <div  cdkDropList 
          class="hover-group" 
          *ngIf="idx == 0 && (showGroupsObs | async)" 
          [cdkDropListData]="{
            groupIdx: -0.5
          }"
          
          (cdkDropListDropped)="drop($event)"
      ></div>

    <ss-activity-item-group 
      
      [groupIndex]="getGroupIndex(activitiesGroupTuple)"
      [activities]="getActivities(activitiesGroupTuple)">
    </ss-activity-item-group>

    <div cdkDropList 
        *ngIf="showGroupsObs | async"
        [cdkDropListData]="{
          groupIdx: getGroupIndex(activitiesGroupTuple) + 0.5
        }" 
        (cdkDropListDropped)="drop($event)" 
        class="hover-group"
    >
    </div>
  </ng-container>
</div>



